// 样式配置的相关逻辑

import { reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { getActivityConfig } from '@/api/activity'
import { getQueryString } from '@/utils/tools'

// 更多图标
const moreIcon = require('../assets/img/home-more.png')

// 图标
const studyIcon = require('../assets/img/study-icon.png')
const testIcon = require('../assets/img/test-exam-icon.png')
const examIcon = require('../assets/img/exam-icon.png')

// 主题图片
const campusBg = require('../assets/img/theme/campus-bg.png')
const campusContentBg = require('../assets/img/theme/campus-content-bg.png')

const businessBg = require('../assets/img/theme/business-bg.png')
const businessContentBg = require('../assets/img/theme/business-content-bg.png')

const countryBg = require('../assets/img/theme/country-bg.png')
const countryContentBg = require('../assets/img/theme/country-content-bg.png')

const survey = require('../assets/img/theme/survey-bg.png')
const surveyContentBg = require('../assets/img/theme/survey-content-bg.png')

const examBg = require('../assets/img/theme/exam-bg.png')
const examContentBg = require('../assets/img/theme/exam-content-bg.png')

// 闯关样式
export const useCommonStyleEffect = () => {
  let isNormal = false
  const styleObj = {
    coverImg: null,
    backImg: null,
  }
  const store = useStore()
  // answerType 1为党建 2为通用 3为自主上传
  if (store.getters.getQuesSetting?.answerType === 3) {
    isNormal = true
    if (store.getters.getQuesSetting?.coverImg) {
      styleObj.coverImg = {
        background: `no-repeat top/100%
        url(${store.getters.getQuesSetting?.coverImg})`,
      }
    }
    if (store.getters.getQuesSetting?.backImg) {
      styleObj.backImg = {
        background: `no-repeat top/100%
        url(${store.getters.getQuesSetting?.backImg})`,
      }
    }
  } else if (store.getters.getQuesSetting?.answerType === 2) {
    isNormal = true
  } else {
    isNormal = false
  }

  return {
    isNormal,
    styleObj,
  }
}

// 活动样式
export const useCommonActiveStyleEffect = () => {
  const loading = ref(true)
  const config = reactive({
    activeType: 0,
    coverImgObj: null,
    backImgObj: null,
  })

  const backImg = getQueryString('backImg')
  const coverImg = getQueryString('coverImg')
  const activeId = getQueryString('activeId')
  const getConfig = async () => {
    try {
      const res = await getActivityConfig({
        id: activeId,
      })
      if (res.ok) {
        config.activeType = res.data ? res.data.activeType : 2
        if (res.data.activeType === 1) {
          config.activeType = 2
        }
        if (res.data.activeType === 3 && res.data.coverImg) {
          config.coverImgObj = {
            background: `no-repeat top/100%
            url(${res.data.coverImg})`,
          }
        }
        if (res.data.activeType === 3 && res.data.backImg) {
          config.backImgObj = {
            background: `no-repeat top/100%
            url(${res.data.backImg})`,
          }
        }
      }
      loading.value = false
    } catch (e) {
      loading.value = false
    }
  }

  if (backImg || coverImg) {
    config.coverImgObj = {
      background: `no-repeat top/100%
      url(${coverImg})`,
    }
    config.backImgObj = {
      background: `no-repeat top/100%
      url(${backImg})`,
    }
    config.activeType = 3
  } else {
    getConfig()
  }

  return {
    config,
    loading,
  }
}

// 整体样式配置
export const useComminDiyStyleEffect = () => {
  let cssOption = reactive({
    cover: {},
    coverC: {},
    content: {},
    contentC: {},
    result: {},
  })
  const diyStyle = document.getElementById('diyStyle')
  const store = useStore()
  const router = useRouter()
  const route = useRoute()

  // 设置按钮显示配置
  const setBtnDisplayConfig = (data) => {
    let showRankBtn = true
    let showTipsBtn = true
    if (data?.cover?.showBtns?.includes('rank')) {
      showRankBtn = true
    } else {
      showRankBtn = false
    }
    if (data?.cover?.showBtns?.includes('tips')) {
      showTipsBtn = true
    } else {
      showTipsBtn = false
    }
    store.commit('initQuesInfo', {
      data: {
        ...store.getters?.getQuesInfo,
        showRankBtn,
        showTipsBtn,
      },
    })
  }

  // postmessage 设置通信样式
  const usePostMessageEffect = () => {
    let quesInfo = store.getters?.getQuesInfo
    // 接受postmessage的数据
    const receiveMessage = (event) => {
      const { data } = event

      // 控制跳转
      if (data.jump) {
        if (data.jump === 'home') {
          router.replace({
            path: '/',
            query: {
              ...route.query,
            },
          })
        } else if (data.jump === 'back') {
          if (route.path === '/result' || route.path === '/ques-result') {
            router.replace({
              path: '/list',
              query: {
                ...route.query,
              },
            })
          } else if (route.path === '/list') {
            router.replace({
              path: '/',
              query: {
                ...route.query,
              },
            })
          }
        } else if (data.jump === 'forword') {
          let path = '/list'
          if (store.getters?.getQuesSetting?.isLevel === 2 || store.getters?.getQuesSetting?.isLevel === 3) {
            path = '/competition/question'
          }
          router.replace({
            path,
            query: {
              ...route.query,
            },
          })
        } else {
          if (store.getters?.getQuesInfo?.type === 3) {
            if (store.getters?.getQuesSetting?.isLevel === 2) {
              router.replace({
                path: '/competition/result',
                query: {
                  ...route.query,
                },
              })
            } else if (store.getters?.getQuesSetting.isLevel === 3) {
              router.replace({
                path: '/competition/pk-result',
                query: {
                  ...route.query,
                },
              })
            } else {
              router.replace({
                path: '/result',
                query: {
                  ...route.query,
                },
              })
            }
          } else {
            router.replace({
              path: '/ques-result',
              query: {
                ...route.query,
              },
            })
          }
        }
        parent.postMessage(
          {
            type: data.jump,
          },
          '*'
        )
      }
      // 判断是否是刷新信号
      if (data.isRefresh) {
        location.reload()
      }
      if (!data.isSelf) {
        return
      }
      // 增加显示配置到quesInfo
      setBtnDisplayConfig(data)
      cssOption = data
      // 设置主题css
      if (data.setTheme) {
        quesInfo = {
          type: store.getters?.getQuesInfo.type,
          themeType: data.themeType,
        }
        setThemeStyle(quesInfo, cssOption)
      }

      // 横排只有一个按钮的时候设置
      let btnStyleFlag = 0
      if (store.getters?.getQuesSetting?.isExam === 2) {
        btnStyleFlag += 1
      }
      if (store.getters?.getQuesSetting?.isMock === 2) {
        btnStyleFlag += 1
      }
      if (store.getters?.getQuesSetting?.isStudy === 2) {
        btnStyleFlag += 1
      }
      // 设置css
      if (store.getters?.getQuesSetting?.isLevel === 2) {

        // 闯关首页css
        diyStyle.innerHTML = setCompetitionStyle(cssOption, quesInfo)
      } else if (store.getters?.getQuesSetting?.isLevel === 3) {
        // pk首页css
        diyStyle.innerHTML = setPkStyle(cssOption, quesInfo)
      } else {
        // 普通首页css
        diyStyle.innerHTML = setAnswerStyle(
          {
            ...cssOption,
            btnStyleFlag: btnStyleFlag,
          },
          quesInfo,
          store,
          route,
          router
        )
      }
      // 设置轮播图
      store.commit('setSwiperList', {
        list: cssOption?.content?.swiperList,
      })
      // 设置变量
      setVariable(cssOption, store)

      // 设置按钮文字
      setBtnText(cssOption, store)
    }

    window.addEventListener('message', receiveMessage, false)
  }

  // 接口获取css配置
  const setApiSyleConfig = (quesInfo, quesSetting, styleOption) => {
    let btnStyleFlag = 0
    if (quesSetting?.isExam === 2) {
      btnStyleFlag += 1
    }
    if (quesSetting?.isMock === 2) {
      btnStyleFlag += 1
    }
    if (quesSetting?.isStudy === 2) {
      btnStyleFlag += 1
    }
    if (!styleOption) {
      return
    }
    const css = JSON.parse(styleOption)

    setBtnDisplayConfig(css)
    // 设置主题
    if (quesInfo?.themeType !== null && quesInfo?.themeType !== 0) {
      setThemeStyle(quesInfo, css)
      if (quesSetting?.isLevel === 2) {
        // 闯关首页css
        diyStyle.innerHTML = setCompetitionStyle(css)
      } else if (quesSetting?.isLevel === 3) {
        // pk首页css
        diyStyle.innerHTML = setPkStyle(css)
      } else {
        // 普通答题首页css
        diyStyle.innerHTML = setAnswerStyle(
          {
            ...css,
            btnStyleFlag: btnStyleFlag,
          },
          quesInfo,
          store,
          route,
          router
        )
      }
    }
    // 设置轮播图
    store.commit('setSwiperList', {
      list: css?.content?.swiperList,
    })
    if (quesSetting?.isLevel === 2) {
      // 闯关首页css
      diyStyle.innerHTML += setCompetitionStyle(css)
    } else if (quesSetting?.isLevel === 3) {
      // pk首页css
      diyStyle.innerHTML += setPkStyle(css)
    } else {
      // 普通答题首页css
      diyStyle.innerHTML += setAnswerStyle(
        {
          ...css,
          btnStyleFlag: btnStyleFlag,
        },
        quesInfo,
        store,
        route,
        router
      )
    }
    // 设置文字相关配置
    setVariable(css, store)
    // 设置按钮文字
    setBtnText(css, store)
  }

  usePostMessageEffect()

  return {
    setApiSyleConfig,
  }
}

// 设置变量
const setVariable = (css, store) => {
  // 结果页提示文字
  const result = css?.result
  if (result?.tipText !== undefined) {
    store.commit('setResultTipText', {
      text: result.tipText,
    })
  } else {
    store.commit('setResultTipText', {
      init: true,
    })
  }

  result?.tipImg && store.commit('setResultTipImg', {
    img: result?.tipImg,
  })


  if (result?.finishBtnText !== undefined) {
    store.commit('setFinishBtnText', {
      text: result.finishBtnText,
    })
  }

  // 闯关结果页完成按钮提示文字
  if (css?.resultC?.finishBtnText !== undefined) {
    store.commit('setFinishBtnText', {
      text: css?.resultC?.finishBtnText,
    })
  }
}

// 设置按钮问题
function handleSetBtnDisplayAndText(css, store, key, defaultText) {

}

// 设置按钮问题
const setBtnText = (css, store) => {
  if (css?.cover?.studyBtnText !== undefined) {
    store.commit('setBtnText', {
      studyBtn: css?.cover?.studyBtnText,
    })
  }

  if (css?.cover?.mockBtnText !== undefined) {
    store.commit('setBtnText', {
      mockBtn: css?.cover?.mockBtnText,
    })
  }

  if (css?.cover?.examBtnText !== undefined) {
    store.commit('setBtnText', {
      examBtn: css?.cover?.examBtnText,
    })
  }

  // 试题说明
  if (css?.cover?.explainBtnText !== undefined) {
    store.commit('setBtnText', {
      explainBtn: css?.cover?.explainBtnText,
    })
  }

  if (css?.cover?.rankBtnText !== undefined) {
    store.commit('setBtnText', {
      rankBtn: css?.cover?.rankBtnText,
    })
  }

  if (css?.cover?.scoreBtnText !== undefined) {
    store.commit('setBtnText', {
      scoreBtn: css?.cover?.scoreBtnText,
    })
  }

  if (css?.cover?.infoBtnText !== undefined) {
    store.commit('setBtnText', {
      infoBtn: css?.cover?.infoBtnText,
    })
  }

  if (css?.cover?.recordBtnText !== undefined) {
    store.commit('setBtnText', {
      recordBtn: css?.cover?.recordBtnText,
    })
  }

  if (css?.cover?.otherBtnText !== undefined) {
    store.commit('setBtnText', {
      otherBtn: css?.cover?.otherBtnText,
    })
  }

  if (css?.cover?.otherUrl !== undefined) {
    store.commit('setBtnText', {
      otherUrl: css?.cover?.otherUrl,
    })
  }

  if (css?.cover?.btnSort !== undefined) {
    store.commit('setBtnText', {
      btnSort: css?.cover?.btnSort,
    })
  }

  if (css?.cover?.moreBtnsShow !== undefined) {
    store.commit('setBtnText', {
      moreBtnsShow: css?.cover?.moreBtnsShow ? '1' : '0',
    })
  }

  if (css?.cover?.moreBtnList !== undefined) {
    store.commit('setBtnText', {
      moreBtnList: css?.cover?.moreBtnList,
    })
  }

  if (css?.cover?.quesBtnText !== undefined) {
    store.commit('setBtnText', {
      quesBtn: css?.cover?.quesBtnText,
    })
  }
  console.log('css?.coverC?.compBtnText', css?.coverC?.compBtnText)
  if (css?.coverC?.compBtnText !== undefined) {
    store.commit('setBtnText', {
      compBtnText: css?.coverC?.compBtnText,
    })
  }

  // 不显示的时候，按钮文字为空，用来控制按钮的显示，省字段
  if (!css?.cover?.personalBtnShow) {
    store.commit('setBtnText', {
      personalBtn: '',
    })
  } else {
    store.commit('setBtnText', {
      personalBtn: store.state.btnText.personalBtn || '个人信息',
    })
  }
  if (
    css?.cover?.personalBtnText !== undefined &&
    css?.cover?.personalBtnShow
  ) {
    let btnText = css?.cover?.personalBtnText

    store.commit('setBtnText', {
      personalBtn: btnText,
    })
  }
  // 报名记录
  if (!css?.cover?.quesRecordBtnShow) {
    store.commit('setBtnText', {
      quesRecordBtnText: '',
    })
  } else {
    store.commit('setBtnText', {
      quesRecordBtnText: store.state.btnText.quesRecordBtnText || '报名记录',
    })
  }
  if (
    css?.cover?.quesRecordBtnText !== undefined &&
    css?.cover?.quesRecordBtnShow
  ) {
    let btnText = css?.cover?.quesRecordBtnText

    store.commit('setBtnText', {
      quesRecordBtnText: btnText,
    })
  }

  // 我的证书
  if (css?.cover?.certificateBtnText !== undefined) {
    store.commit('setBtnText', {
      certificateBtnText: css?.cover?.certificateBtnText,
    })
  }

  // 不显示的时候，按钮文字为空，用来控制按钮的显示，省字段
  if (!css?.cover?.adminBtnShow) {
    store.commit('setBtnText', {
      adminBtn: '',
    })
  } else {
    store.commit('setBtnText', {
      adminBtn: store.state.btnText.adminBtn || '填报管理',
    })
  }
  if (css?.cover?.adminBtnText !== undefined && css?.cover?.adminBtnShow) {
    let btnText = css?.cover?.adminBtnText

    store.commit('setBtnText', {
      adminBtn: btnText,
    })
  }

  // 结果页证书弹窗设置
  if (css?.result?.certificateTitle !== undefined) {
    store.commit('setCertificateTitle', {
      title: css?.result?.certificateTitle,
    })
  }
  if (css?.result?.certificateTitleAlign !== undefined) {
    store.commit('setCertificateTitleAlign', {
      data: css?.result?.certificateTitleAlign,
    })
  }
  if (css?.result?.certificateSubmitBtnText !== undefined) {
    store.commit('setCertificateSubmitBtnText', {
      text: css?.result?.certificateSubmitBtnText,
    })
  }

}

// 设置主题样式, 这里设置的都是可以后续覆盖的样式
const setThemeStyle = (quesInfo, cssOption) => {
  const tmp = {
    cover: {
      coverType: 1,
      themeType: 2,
      bgImg: '',
    },
    content: {
      bgType: 1,
      bgAlpha: 0,
    },
  }
  // 校园主题
  if (quesInfo?.themeType === 1) {
    tmp.cover.bgImg = campusBg
    tmp.cover.showDesc = false
    tmp.cover.titleFont = 40
    tmp.cover.titleColor = '#113564'
    tmp.content.bgImg = campusContentBg
  }
  // 商务主题
  if (quesInfo?.themeType === 2) {
    tmp.cover.bgImg = businessBg
    tmp.content.bgImg = businessContentBg
    tmp.cover.titleFont = 43
    tmp.cover.titleColor = '#fff'
    tmp.cover.descBg = '#225FC8'
    tmp.cover.descColor = '#fff'
    tmp.content.quesColor = '#fff'
  }
  // 党建
  if (quesInfo?.themeType === 3) {
    tmp.cover.bgImg = countryBg
    tmp.content.bgImg = countryContentBg
    tmp.cover.titleFont = 43
    tmp.cover.titleColor = '#FFDB9D'
    tmp.cover.descBg = '#B7180B'
    tmp.cover.descColor = '#fff'
    tmp.cover.btnBgStartColor = '#FA6F51'
    tmp.cover.btnBgEndColor = '#EFC96D'
    tmp.cover.btn1BgStartColor = '#FA6F51'
    tmp.cover.btn1BgEndColor = '#EFC96D'
    tmp.cover.btn2BgStartColor = '#FA6F51'
    tmp.cover.btn2BgEndColor = '#EFC96D'
    tmp.cover.btn3BgStartColor = '#FA6F51'
    tmp.cover.btn3BgEndColor = '#EFC96D'
    tmp.cover.btn4BgStartColor = '#FA6F51'
    tmp.cover.btn4BgEndColor = '#EFC96D'
    tmp.cover.btn5BgStartColor = '#FA6F51'
    tmp.cover.btn5BgEndColor = '#EFC96D'
    tmp.cover.btn6BgStartColor = '#FA6F51'
    tmp.cover.btn6BgEndColor = '#EFC96D'
    tmp.cover.btn7BgStartColor = '#FA6F51'
    tmp.cover.btn7BgEndColor = '#EFC96D'
    tmp.cover.btn8BgStartColor = '#FA6F51'
    tmp.cover.btn8BgEndColor = '#EFC96D'
    tmp.cover.btn9BgStartColor = '#FA6F51'
    tmp.cover.btn9BgEndColor = '#EFC96D'
    tmp.content.titleColor = '#fff'
    tmp.content.bgAlpha = 10
    tmp.content.quesColor = '#fff'
    tmp.content.optionColor = '#fff'
    tmp.cover.certificateBtnBgEndColor = '#EFC96D'
    tmp.cover.certificateBtnBgStartColor = '#FA6F51'
  }
  // 满意度
  if (quesInfo?.themeType === 4) {
    tmp.cover.bgImg = survey
    tmp.cover.titleColor = '#3246DD'
    tmp.content.bgImg = surveyContentBg
    tmp.content.titleColor = '#333'
    tmp.content.bgColor = '#C3EAFF'
    tmp.cover.descBg = '#fff'
  }
  // 考试
  if (quesInfo?.themeType === 5) {
    tmp.cover.bgImg = examBg
    tmp.cover.titleColor = '#fff'
    tmp.content.bgImg = examContentBg
    tmp.content.titleColor = '#fff'
    tmp.cover.quesColor = '#fff'
    tmp.cover.descBg = '#fff'
  }
  cssOption.cover = {
    ...tmp.cover,
    ...cssOption.cover,
  }
  cssOption.content = {
    ...tmp.content,
    ...cssOption.content,
  }
}

// 设置普通答题样式
const setAnswerStyle = (cssOption, quesInfo, store, route, router) => {
  let css =
    formatCoverStyle(cssOption, quesInfo, store, route, router) +
    formatContentStyle(cssOption, quesInfo) +
    formatResultStyle(cssOption, quesInfo)
  if (quesInfo?.themeType) {
    css += formatThemeStyle(cssOption, quesInfo)
  }

  return css
}

// 设置普通首页样式
const formatCoverStyle = (cssOption, quesInfo, store, route, router) => {
  const cover = cssOption.cover || {}

  if (cover.hideHome === true) {
    store.commit('setIsHideHome', true)
    console.log('route.query.isSetting', route.query.isSetting)
    // 后台设置的时候，路由需要配合跳转
    route.query.isSetting && router.replace({
      path: '/list',
      query: {
        ...route.query,
      },
    })
  }

  if (cover.hideHome === false) {
    store.commit('setIsHideHome', false)

    // 后台设置的时候，路由需要配合跳转
    route.query.isSetting &&  router.replace({
      path: '/',
      query: {
        ...route.query,
      },
    })
  }

  let css = `
  .cover .title {
    visibility: ${
      cssOption.cover?.showTitle === false ? 'hidden' : 'visible'
    } !important;
    font-size: ${((cssOption?.cover?.titleFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.cover?.titleColor} !important;
    font-weight: ${cssOption?.cover?.titleFontBold} !important;
    font-style: ${cssOption?.cover?.titleFontItalic} !important;
    text-decoration: ${cssOption?.cover?.titleFontUnderline} !important;
  }
  .cover .tips {
    visibility: ${
      cssOption.cover?.showDesc === false ? 'hidden' : 'visible'
    } !important;
    background: ${cssOption?.cover?.descBg} !important;
  }
  .cover .tips, .cover .tips font, .tips span {
    font-size: ${((cssOption?.cover?.descFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.cover?.descColor} !important;
    font-weight: ${cssOption?.cover?.descFontBold} !important;
    font-style: ${cssOption?.cover?.descFontItalic} !important;
    text-decoration: ${cssOption?.cover?.descFontUnderline} !important;
  }
  .cover .tips p {
    font-size: ${((cssOption?.cover?.descFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.cover?.descColor} !important;
  }
  .cover .modules .modules-item .modules-item-text {
    color: ${cssOption?.cover?.btnColor} !important;
    font-size: ${((cssOption?.cover?.btnFont * 2) / 50)?.toFixed(
      2
    )}rem !important;
  }
  .modules .modules-item {
    font-weight: ${cssOption?.cover?.btnFontBold} !important;
    font-style: ${cssOption?.cover?.btnFontItalic} !important;
    text-decoration: ${cssOption?.cover?.btnFontUnderline} !important;
  }

`

  // 页面高度
  if (cover?.coverHeight) {
    css += `
    .cover {
      height: ${(cover?.coverHeight / 50).toFixed(2)}rem !important;
    }
    `
  }

  // 按钮宽度
  if (cssOption?.cover?.moduleBtnWidth !== undefined) {
    css += `
    .cover .modules .modules-item {
      width: ${((cssOption?.cover?.moduleBtnWidth * 2) / 50).toFixed(
        2
      )}rem !important;
    }
    `
  }

  // 按钮高度
  if (cssOption?.cover?.moduleBtnHeight !== undefined) {
    css += `
    .cover .modules .modules-item {
      height: ${((cssOption?.cover?.moduleBtnHeight * 2) / 50).toFixed(
        2
      )}rem !important;
    }
    `
  }

  // 按钮组上边距
  if (cssOption?.cover?.btnGroupMarginTop !== undefined) {
    css += `
    .cover .modules {
      margin-top: ${(cssOption?.cover?.btnGroupMarginTop / 50).toFixed(
        2
      )}rem !important;
    }
    `
  }

  // 按钮组下边距
  if (cssOption?.cover?.btnGroupMarginBottom !== undefined) {
    css += `
    .cover .modules {
      margin-bottom: ${(cssOption?.cover?.btnGroupMarginBottom / 50).toFixed(
        2
      )}rem !important;
    }
    `
  }

  // 按钮之间底边距
  if (cssOption?.cover?.btnBottomMargin !== undefined) {
    css += `
    .cover .modules .modules-item {
      margin-bottom: ${(cssOption?.cover?.btnBottomMargin / 50).toFixed(
        2
      )}rem !important;
    }
    `
  }

  // 按钮圆角
  if (cssOption?.cover?.btnRadius) {
    css += `
    .cover .modules .modules-item {
      border-radius: ${cssOption?.cover?.btnRadius?.toFixed(2)}px !important;
    }
    `
  }

  // 普通封面背景
  if (cssOption?.cover?.themeType === 1 && quesInfo?.type !== 1) {
    css += `
    .cover .tips {
      margin-top: ${(290 / 50).toFixed(2)}rem !important;
    }
    `
  }
  if (cssOption?.cover?.themeType === 2 && quesInfo?.type !== 1) {
    // 横排-
    css += `
    .cover .tips {
        margin-top: ${(290 / 50).toFixed(2)}rem !important;
    }
    `
    if (cssOption?.btnStyleFlag !== 0) {
      css += `
      .cover .modules {
        overflow: auto;
        padding-left: 0.1rem;
        // display: flex !important;
      }
      .cover .modules .modules-item {
        float: left;
        margin-left: 1rem;
        width: ${(224 / 38).toFixed(2)}rem !important;
        height: ${(85 / 38).toFixed(2)}rem !important;
      }
      .cover .modules .modules-item .modules-item-icon {
        margin-left: 2px !important;
        width: ${(64 / 38).toFixed(2)}rem !important;
        height: ${(64 / 38).toFixed(2)}rem !important;
      }
      .cover .modules .modules-item .icon-study {
        background: no-repeat left/100% url(${studyIcon}) !important;
      }
      .cover .modules .modules-item .icon-test {
        background: no-repeat left/100% url(${testIcon}) !important;
      }
      .cover .modules .modules-item .icon-exam {
        background: no-repeat left/100% url(${examIcon}) !important;
      }
      .cover .modules .modules-item .modules-item-text {
        margin-left: 5px !important;
        font-size: ${(30 / 50).toFixed(2)}rem;
      }
      .cover .logo {
        visibility: hidden;
      }
      `
    }
  }
  if (cssOption?.cover?.themeType === 3 && quesInfo?.type !== 1) {
    // 横排-
    css += `
    .cover .tips {
        margin-top: ${(260 / 50).toFixed(2)}rem !important;
        margin-bottom: ${(30 / 50).toFixed(2)}rem !important;
    }
    `
    if (cssOption?.btnStyleFlag !== 0) {
      css += `
      .cover .modules {
        overflow:auto;
        margin: 0 0.26rem;
        // display: flex !important;
      }
      .cover .modules .modules-item {
        float: left;
        margin-left: 0.25rem;
        width: ${(224 / 50).toFixed(2)}rem !important;
        height: ${(85 / 50).toFixed(2)}rem !important;
      }
      .cover .modules .modules-item .modules-item-icon {
        margin-left: 2px !important;
        width: ${(64 / 50).toFixed(2)}rem !important;
        height: ${(64 / 50).toFixed(2)}rem !important;
      }
      .cover .modules .modules-item .icon-study {
        background: no-repeat left/100% url(${studyIcon}) !important;
      }
      .cover .modules .modules-item .icon-test {
        background: no-repeat left/100% url(${testIcon}) !important;
      }
      .cover .modules .modules-item .icon-exam {
        background: no-repeat left/100% url(${examIcon}) !important;
      }
      .cover .modules .modules-item .modules-item-text {
        margin-left: 5px !important;
        font-size: ${(30 / 50).toFixed(2)}rem;
      }
      .cover .logo {
        visibility: hidden;
      }
      `
    }
  }
  if (cssOption?.cover?.coverType === 1 && cssOption?.cover?.bgImg) {

    css += `
    boyd {
      background: none !important;
    }
    .cover {
      background: no-repeat top/100% url(${cssOption?.cover?.bgImg}) !important;
      min-height: ${
        cssOption?.cover?.bgImgSize == undefined
          ? '100vh'
          : ((cssOption?.cover?.bgImgSize?.width / 750) *
              cssOption?.cover?.bgImgSize?.height) /
              50 +
            'rem'
      } ;
    }
    `
  } else if (cssOption?.cover?.coverType === 2) {
    // 纯色背景
    css += `
    boyd {
      background-color: ${cssOption?.cover?.coverColor} !important;
    }
    .cover {
      background-image: none !important;
      background-color: ${cssOption?.cover?.coverColor} !important;
      min-height: 100vh;
    }
    `
  }
  // 统一按钮背景颜色设置
  const btnBgStartColor = cssOption?.cover?.btnBgStartColor || '#40afff '
  const btnBgEndColor = cssOption?.cover?.btnBgEndColor || '#3573fa '
  if (cssOption?.cover?.btnBgStartColor || cssOption?.cover?.btnBgEndColor) {
    css += `
  .modules .modules-item {
    background: linear-gradient(
      -90deg
      , ${btnBgStartColor} 0%, ${btnBgEndColor} 100%) !important;
  }
  `
  }

  // 个人信息按钮背景颜色设置
  const personalBtnStartColor =
    cssOption?.cover?.personalBtnStartColor || '#40afff '
  const personalBtnEndColor =
    cssOption?.cover?.personalBtnEndColor || '#3573fa '
  if (
    cssOption?.cover?.personalBtnStartColor ||
    cssOption?.cover?.personalBtnEndColor
  ) {
    css += `
  .modules .ques-person-btn {
    background: linear-gradient(
      -90deg
      , ${personalBtnStartColor} 0%, ${personalBtnEndColor} 100%) !important;
  }
  `
  }

  // 报名记录按钮背景颜色设置
  const quesRecordBtnStartColor =
    cssOption?.cover?.quesRecordBtnStartColor || '#40afff '
  const quesRecordBtnEndColor =
    cssOption?.cover?.quesRecordBtnEndColor || '#3573fa '
  if (
    cssOption?.cover?.quesRecordBtnStartColor ||
    cssOption?.cover?.quesRecordBtnEndColor
  ) {
    css += `
  .modules .ques-record-btn {
    background: linear-gradient(
      -90deg
      , ${quesRecordBtnStartColor} 0%, ${quesRecordBtnEndColor} 100%) !important;
  }
  `
  }

  // 填报管理按钮背景颜色设置
  const adminBtnStartColor = cssOption?.cover?.adminBtnStartColor || '#40afff '
  const adminBtnEndColor = cssOption?.cover?.adminBtnEndColor || '#3573fa '
  if (
    cssOption?.cover?.adminBtnStartColor ||
    cssOption?.cover?.adminBtnEndColor
  ) {
    css += `
    .modules .ques-admin-btn {
      background: linear-gradient(
        -90deg
        , ${adminBtnStartColor} 0%, ${adminBtnEndColor} 100%) !important;
    }
    `
  }

  // 试题学习按钮背景颜色设置
  const btn1BgStartColor = cssOption?.cover?.btn1BgStartColor || '#40afff '
  const btn1BgEndColor = cssOption?.cover?.btn1BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn1BgStartColor || cssOption?.cover?.btn1BgEndColor) {
    css += `
  .modules .btn1 {
    background: linear-gradient(
      -90deg
      , ${btn1BgStartColor} 0%, ${btn1BgEndColor} 100%) !important;
  }
  `
  }
  // 模拟考试按钮背景颜色设置
  const btn2BgStartColor = cssOption?.cover?.btn2BgStartColor || '#40afff '
  const btn2BgEndColor = cssOption?.cover?.btn2BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn2BgStartColor || cssOption?.cover?.btn2BgEndColor) {
    css += `
  .modules .btn2 {
    background: linear-gradient(
      -90deg
      , ${btn2BgStartColor} 0%, ${btn2BgEndColor} 100%) !important;
  }
  `
  }
  // 正式考试按钮背景颜色设置
  const btn3BgStartColor = cssOption?.cover?.btn3BgStartColor || '#40afff '
  const btn3BgEndColor = cssOption?.cover?.btn3BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn3BgStartColor || cssOption?.cover?.btn3BgEndColor) {
    css += `
  .modules .btn3 {
    background: linear-gradient(
      -90deg
      , ${btn3BgStartColor} 0%, ${btn3BgEndColor} 100%) !important;
  }
  `
  }
  // 试题说明按钮背景颜色设置
  const btn4BgStartColor = cssOption?.cover?.btn4BgStartColor || '#40afff '
  const btn4BgEndColor = cssOption?.cover?.btn4BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn4BgStartColor || cssOption?.cover?.btn4BgEndColor) {
    css += `
  .modules .btn4 {
    background: linear-gradient(
      -90deg
      , ${btn4BgStartColor} 0%, ${btn4BgEndColor} 100%) !important;
  }
  `
  }
  // 参赛排行按钮背景颜色设置
  const btn5BgStartColor = cssOption?.cover?.btn5BgStartColor || '#40afff '
  const btn5BgEndColor = cssOption?.cover?.btn5BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn5BgStartColor || cssOption?.cover?.btn5BgEndColor) {
    css += `
  .modules .btn5 {
    background: linear-gradient(
      -90deg
      , ${btn5BgStartColor} 0%, ${btn5BgEndColor} 100%) !important;
  }
  `
  }
  // 我的成绩按钮背景颜色设置
  const btn6BgStartColor = cssOption?.cover?.btn6BgStartColor || '#40afff '
  const btn6BgEndColor = cssOption?.cover?.btn6BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn6BgStartColor || cssOption?.cover?.btn6BgEndColor) {
    css += `
  .modules .btn6 {
    background: linear-gradient(
      -90deg
      , ${btn6BgStartColor} 0%, ${btn6BgEndColor} 100%) !important;
  }
  `
  }
  // 个人信息按钮背景颜色设置
  const btn7BgStartColor = cssOption?.cover?.btn7BgStartColor || '#40afff '
  const btn7BgEndColor = cssOption?.cover?.btn7BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn7BgStartColor || cssOption?.cover?.btn7BgEndColor) {
    css += `
  .modules .btn7 {
    background: linear-gradient(
      -90deg
      , ${btn7BgStartColor} 0%, ${btn7BgEndColor} 100%) !important;
  }
  `
  }
  // 答卷记录按钮背景颜色设置
  const btn8BgStartColor = cssOption?.cover?.btn8BgStartColor || '#40afff '
  const btn8BgEndColor = cssOption?.cover?.btn8BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn8BgStartColor || cssOption?.cover?.btn8BgEndColor) {
    css += `
  .modules .btn8 {
    background: linear-gradient(
      -90deg
      , ${btn8BgStartColor} 0%, ${btn8BgEndColor} 100%) !important;
  }
  `
  }
  // 其他按钮背景颜色设置
  const btn9BgStartColor = cssOption?.cover?.btn9BgStartColor || '#40afff '
  const btn9BgEndColor = cssOption?.cover?.btn9BgEndColor || '#3573fa '
  if (cssOption?.cover?.btn9BgStartColor || cssOption?.cover?.btn9BgEndColor) {
    css += `
  .modules .btn9 {
    background: linear-gradient(
      -90deg
      , ${btn9BgStartColor} 0%, ${btn9BgEndColor} 100%) !important;
  }
  `
  }

  // 我的证书按钮颜色
  const certificateBtnBgStartColor = cssOption?.cover?.certificateBtnBgStartColor || '#40afff '
  const certificateBtnBgEndColor = cssOption?.cover?.certificateBtnBgEndColor || '#3573fa '

  if (
    cssOption?.cover?.certificateBtnBgStartColor ||
    cssOption?.cover?.certificateBtnBgEndColor
  ) {
    css += `.modules .certificate-btn {
        background: linear-gradient(-90deg,
          ${certificateBtnBgStartColor} 0%, ${certificateBtnBgEndColor} 100%) !important;
    }
  `
  }

  return css
}
// 设置内容页样式
const formatContentStyle = (cssOption, quesInfo) => {
  let css = ''
  // 背景设置
  if (cssOption?.content?.bgType === 1 && cssOption?.content?.bgImg) {
    css += `
    .main-content {
      margin: 0 auto !important;
      min-height: 100vh !important;
    }
    .content-wrap .choice-title {
      margin-top: 0 !important;
      padding-top: 0.94rem;
    }
    // .footer {
    //   color: #fff !important;
    //   background: none !important;
    // }
    .content-diy-bg {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      min-height: 32.48rem;
      background: no-repeat top/100% url(${cssOption?.content?.bgImg}) !important;
      z-index: -1;
    }
    `
  } else if (cssOption?.content?.bgType === 2) {
    // 纯色背景
    css += `
    .main-content {
      margin: 0 auto !important;
      min-height: 100vh !important;
    }
    .content-wrap .choice-title {
      margin-top: 0 !important;
      padding-top: 0.94rem;
    }
    .content-diy-bg {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      min-height: 32.48rem;
      background-image: none !important;
      background-color: ${cssOption?.content?.bgColor} !important;
      z-index: -1;
    }
    `
  }
  // 背景透明度
  css += `
  .main-content {
    background: rgba(255, 255, 255, ${(
      cssOption?.content?.bgAlpha / 100
    ).toFixed(2)}) !important;
  }
  .ques-content {
    padding-bottom: 20px;
    background: transparent !important;
  }
  .content-wrap .choice {
    background: transparent !important;
  }
  `
  // 背景透明度为0的时候 给题干内容加白背景 不然看不清楚
  if (cssOption?.content?.bgAlpha === 0) {
    css += `
    .ques-content {
      padding-bottom: 20px;
      background: #fff;
    }
    .content-wrap .choice {
      background: #fff !important;
    }
    `
  }
  // 标题字体
  css += `
  .main-content .ques-title {
    font-size: ${((cssOption?.content?.titleFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.content?.titleColor} !important;
    font-weight: ${cssOption?.content?.titleFontBold} !important;
    font-style: ${cssOption?.content?.titleFontItalic} !important;
    text-decoration: ${cssOption?.content?.titleFontUnderline} !important;
  }
  `
  if (quesInfo?.type === 1) {
    css += `
    .main-content .ques-title {
      display: ${
        cssOption.content?.showTitle === false ? 'none' : 'block'
      } !important;
    }
    `
  } else {
    css += `
    .main-content .ques-title {
      visibility: ${
        cssOption.content?.showTitle === false ? 'hidden' : 'visible'
      } !important;
      display: ${
        cssOption.content?.showTitle === false ? 'none' : 'block'
      } !important;
    }
    `
  }

  // 描述
  css += `
  .main-content .ques-tips {
    display: ${
      cssOption.content?.showDesc === false ? 'none' : 'block'
    } !important;
  }
  .main-content .ques-tips * {
    font-size: ${((cssOption?.content?.descFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.content?.descColor} !important;
    font-weight: ${cssOption?.content?.descFontBold} !important;
    font-style: ${cssOption?.content?.descFontItalic} !important;
    text-decoration: ${cssOption?.content?.descFontUnderline} !important;
  }
  `

  // 题目字体
  css += `
  .main-content .choice-title {
    font-size: ${((cssOption?.content?.quesFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.content?.quesColor} !important;
    font-weight: ${cssOption?.content?.quesFontBold} !important;
    font-style: ${cssOption?.content?.quesFontItalic} !important;
    text-decoration: ${cssOption?.content?.quesFontUnderline} !important;
  }`
  // 选项字体
  css += `
  .main-content .choice .choice-item, .van-checkbox__label, .van-radio__label {
    font-size: ${((cssOption?.content?.optionFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.content?.optionColor} !important;
    font-weight: ${cssOption?.content?.optionFontBold} !important;
    font-style: ${cssOption?.content?.optionFontItalic} !important;
    text-decoration: ${cssOption?.content?.optionFontUnderline} !important;
  }`
  return css
}
// 设置结果页样式
const formatResultStyle = (cssOption, quesInfo) => {
  let css = ''
  const result = cssOption?.result || {}

  // 背景色/背景图 样式
  if (result?.bgType === 1 && result?.bgImg) {
    css += `
      .result-wrap {
        background: no-repeat top/100% url(${result?.bgImg}) !important;
      }
    `
  } else if (result?.bgType === 2) {
    // 纯色背景
    css += `
      .result-wrap {
        background-image: none !important;
        background-color: ${result?.bgColor} !important;
      }
    `
  }

  // 是否隐藏标题图片
  if (result?.isHideIcon) {
    css += `
      .result-wrap .result {
        display: none !important;
      }

      .result-wrap .result-tips {
        margin-top: 0 !important;
        padding-top: ${(350 / 50).toFixed(2)}rem !important;
      }
    `
  }

  // 提示字体样式
  css += `
    .result-wrap .result-tips {
      font-size: ${((result?.titleFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.titleColor} !important;
      font-weight: ${result?.titleFontBold} !important;
      font-style: ${result?.titleFontItalic} !important;
      text-decoration: ${result?.titleFontUnderline} !important;
    }
  `

  // 完成按钮按钮背景颜色设置
  css += `
    .result-wrap .finish-btn {
      background: linear-gradient(
        -90deg
        , ${result?.finishBtnBgStartColor || '#388fff'} 0%, ${
    result?.finishBtnBgEndColor || '#2faeff'
  } 100%) !important;
    }
  `

  // 完成按钮字体设置
  css += `
    .result-wrap .finish-btn {
      font-size: ${((result?.finishBtnFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.finishBtnColor} !important;
      font-weight: ${result?.finishBtnFontBold} !important;
      font-style: ${result?.finishBtnFontItalic} !important;
      text-decoration: ${result?.finishBtnFontUnderline} !important;
    }
  `

  // 完成按钮圆角设置
  css += `
    .result-wrap .finish-btn {
      border-radius: ${((result?.finishBtnRadius || 44) / 50).toFixed(
        2
      )}rem !important;
    }
  `

  // 答题提示背景图,
  if (quesInfo?.type === 3 && result?.tipImg) {
    css += `
      .result-wrap .result {
        background: no-repeat top/100% url(${result?.tipImg}) !important;
      }
    `
  }

  // 答题结果窗背景色
  if (result?.resWrapBgColor) {
    css += `
      .result-wrap .infos-detail-item {
        background-color: ${result?.resWrapBgColor} !important;
      }
    `
  }

  // 答题结果窗上排文字
  css += `
    .result-wrap .infos .infos-detail .infos-detail-item div.normal {
      font-size: ${((result?.resTopFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.resTopFontColor} !important;
      font-weight: ${result?.resTopFontBold} !important;
      font-style: ${result?.resTopFontItalic} !important;
      text-decoration: ${result?.resTopFontUnderline} !important;
    }
  `

  // 答题结果窗下排文字
  css += `
    .result-wrap .infos .infos-detail .infos-detail-item div.grey {
      font-size: ${((result?.resBottomFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.resBottomFontColor} !important;
      font-weight: ${result?.resBottomFontBold} !important;
      font-style: ${result?.resBottomFontItalic} !important;
      text-decoration: ${result?.resBottomFontUnderline} !important;
    }
  `

  return css
}
// 设置主题专属样式
const formatThemeStyle = (cssOption, quesInfo) => {
  let css = `
    .cover {
      background-size: 100% 100% !important;
      background-repeat: no-repeat !important;
      // background-position-y: -2rem !important;
    }
    .ques-type {
      // margin: 0 auto !important;
      // margin-bottom: ${(20 / 50).toFixed(2)}rem;
      width: 14rem !important;
      height: ${(120 / 50).toFixed(2)}rem !important;
      background: linear-gradient(152deg, #3ED6C0, #43B6E6) !important;
      border-radius: ${(60 / 50).toFixed(2)}rem  !important;
      overflow: hidden !important;

      .modules-item-icon, .icon-study {
        width: ${(180 / 50).toFixed(2)}rem  !important;
        height: ${(120 / 50).toFixed(2)}rem  !important;
      }
    }
  `
  // 校园风
  if (quesInfo?.themeType === 1) {
    css += `
    .cover .title {
      padding-top: ${(279 / 50).toFixed(2)}rem !important;
    }
    .cover {
      margin-top: 0 !important;
    }
    .cover .tips {
      margin-top: 6.04rem !important;
    }
    .special-color {
      background: linear-gradient(-90deg, #E86C1B 0%, #FCC30B 100%) !important;
    }
    `
  }
  // 商务风
  if (quesInfo?.themeType === 2) {
    css += `
    body {
      background-color: rgb(16,59,169) !important;
    }
    .cover {
      margin-top: 0 !important;
    }
    // .cover .person-btn {
    //   background: no-repeat center/100% url(${moreIcon}) !important;
    // }
    .cover .title {
      padding-top: ${(288 / 50).toFixed(2)}rem !important;
    }
    .cover .tips {
      margin-top:  5.04rem !important;
      height: ${(385 / 50).toFixed(2)}rem !important;
    }
    .cover .tips, .tips-title, .ques-tips * {
      color: #FFFFFF !important;
    }
    .explanation p {
      color: #7EDEFA !important;
    }
    .special-color {
      background: linear-gradient(-90deg, #FF5854 0%, #FFBB59 100%) !important;
    }
    `
  }
  // 党建风
  const descBg = colorToRgb(cssOption?.cover?.descBg).replace(')', ', .45)')
  if (quesInfo?.themeType === 3) {
    css += `
    body {
      background-color: rgb(161,2,3) !important;
    }
    .cover {
      margin-top: 0 !important;
      // background-position-y: -2rem !important;
    }
    // .cover .person-btn {
    //   background: no-repeat center/100% url(${moreIcon}) !important;
    // }
    .choice-title .tips {
      color: #ffffff !important;
    }
    .cover .title {
      padding-top: ${(288 / 50).toFixed(2)}rem !important;
    }
    .cover .tips {
      margin-top:  3.04rem !important;
      height: 9.5rem !important;
      background: ${descBg} !important;
    }
    .cover .tips-title, .ques-tips * {
      color: #FFFFFF !important;
    }
    .choice .choice-item .select {
      border-color: #F18761 !important;
    }
    .content-wrap .choice .choice-item {
      background-color: transparent;
    }
    .content-wrap .choice .choice-item .van-field__control, .content-wrap .choice .choice-item .van-field__control::placeholder {
      color: #ffffff;

    }
    .main-content .ques-title {
      color: #fff !important;
    }
    .choice input {
      color: #ffffff;
      background: transparent;
    }
    .content-wrap .choice {
      background: transparent !important;
    }
    .choice .upload-wrap .wrap-content {
      color: #ffffff;
    }
    .choice input::placeholder {
      color: #ffffff;
    }
    .van-checkbox__icon--checked .van-icon {
      border-color: #F18761 !important;
      background-color: #F18761 !important;
    }
    .btn-list .btn, .multi-submit, .submit-btn {
      border: none !important;
      background: linear-gradient(-90deg, #FA6F51 0%, #EFC96D 100%) !important;;
    }
    .explanation p {
      color: #FFEF69 !important;
    }

    .person-wrap .ques-item .choice input {
      color: #333;
    }
    .person-wrap .ques-item .choice input::placeholder{
      color: #c8c9cc;
    }
    `
  }
  // 满意度
  if (quesInfo?.themeType === 4) {
    css += `
    body {
      background-color: rgb(195,234,255) !important;
    }
    .cover .tips {
      margin-top:  10.04rem !important;
    }
    .footer {
      background: none !important;
    }
    .explanation p{
      color: #EE4533 !important;
    }
    .special-color {
      background: linear-gradient(-90deg, #A713FF 0%, #CA00FF 100%) !important;
    }
    `
  }
  // 考试
  if (quesInfo?.themeType === 5) {
    css += `
    body {
      background-color: rgb(7,104,250) !important;
    }
    .cover {
      margin-top: 0 !important;
    }
    .cover .title {
      padding-top: ${(174 / 50).toFixed(2)}rem !important;
    }
    .cover .tips {
      margin-top:  7.5rem !important;
    }
    .footer {
      background: none !important;
    }
    .explanation p{
      color: #A2E8FF !important;
    }
    .special-color {
      background: linear-gradient(-90deg, #FFC350 0%, #F98D0E 100%) !important;
    }
    `
  }
  // 普通问卷
  if (quesInfo?.type === 1) {
    css += `
    .cover .tips {
      margin-top: 7.04rem !important;
      height: ${(385 / 50).toFixed(2)}rem !important;
    }
    `
    if (quesInfo?.themeType === 2) {
      css += `
      .cover .tips {
        margin-top:  5.04rem !important;
        height: ${(385 / 50).toFixed(2)}rem !important;
      }
      `
    }
    if (quesInfo?.themeType === 3) {
      css += `
      .cover .tips {
        margin-top:  5.04rem !important;
        height: ${(385 / 50).toFixed(2)}rem !important;
      }
      .main-content .ques-title {
        color: #fff !important;
      }
      `
    }
    if (quesInfo?.themeType === 4) {
      css += `
      .cover .tips {
        margin-top:  10.04rem !important;
        height: ${(385 / 50).toFixed(2)}rem !important;
      }
      .ques-type {
        background: linear-gradient(-90deg, #40AFFF 0%, #3573FA 100%) !important;
      }
      `
    }
    if (quesInfo?.themeType === 5) {
      css += `
      .cover .tips {
        margin-top:  7.5rem !important;
        height: ${(385 / 50).toFixed(2)}rem !important;
      }
      .ques-type {
        background: linear-gradient(-8deg, #EB9037, #FFD674) !important;
      }
      .infos .infos-text, .result + .text {
        color: #ffffff !important;
      }
      `
    }
  }

  // 普通封面背景
  if (cssOption?.cover?.themeType === 1 && quesInfo?.type !== 1) {
    css += `
    .cover .tips {
      margin-top: 0 !important;
    }
    `
  }
  if (cssOption?.cover?.themeType === 2 && quesInfo?.type !== 1) {
    // 横排-
    // if (quesInfo?.themeType !== 3) {
    //   css += `
    // .cover .tips {
    //   margin-top: ${(340 / 50).toFixed(2)}rem !important;
    // }
    // `
    // }
    if (cssOption?.btnStyleFlag !== 0) {
      css += `
      .cover .modules {
        overflow: auto;
        padding-left: 0.1rem;
        // display: flex !important;
      }
      .cover .modules .modules-item {
        float: left;
        margin-left: 1rem;
        width: ${(224 / 38).toFixed(2)}rem !important;
        height: ${(85 / 38).toFixed(2)}rem !important;
      }
      .cover .modules .modules-item .modules-item-icon {
        margin-left: 2px !important;
        width: ${(64 / 38).toFixed(2)}rem !important;
        height: ${(64 / 38).toFixed(2)}rem !important;
      }
      .cover .modules .modules-item .icon-study {
        background: no-repeat left/100% url(${studyIcon}) !important;
      }
      .cover .modules .modules-item .icon-test {
        background: no-repeat left/100% url(${testIcon}) !important;
      }
      .cover .modules .modules-item .icon-exam {
        background: no-repeat left/100% url(${examIcon}) !important;
      }
      .cover .modules .modules-item .modules-item-text {
        margin-left: 5px !important;
        font-size: ${(30 / 50).toFixed(2)}rem !important;
      }
      .cover .logo {
        visibility: hidden;
      }
      `
    }
  }

  return css
}

// 设置闯关样式
const setCompetitionStyle = (cssOption, quesInfo) => {
  console.log('cssOption', cssOption)
  return (
    formatCoverCompetitionStyle(cssOption, quesInfo) +
    formatContentCompetitionStyle(cssOption) +
    formatResultCompetitionStyle(cssOption)
  )
}

// 设置闯关首页样式
const formatCoverCompetitionStyle = (cssOption, quesInfo) => {
  const coverC = cssOption?.coverC || {}

  let css = `
  .cover-leval .title {
    visibility: ${
      cssOption.coverC?.showTitle === false ? 'hidden' : 'visible'
    } !important;
    font-size: ${((cssOption?.coverC?.titleFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.coverC?.titleColor} !important;
    font-weight: ${cssOption?.coverC?.titleFontBold} !important;
    font-style: ${cssOption?.coverC?.titleFontItalic} !important;
    text-decoration: ${cssOption?.coverC?.titleFontUnderline} !important;
  }
  .cover-leval .tips {
    visibility: ${
      cssOption.coverC?.showDesc === false ? 'hidden' : 'visible'
    } !important;
    font-size: ${((cssOption?.coverC?.descFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.coverC?.descColor} !important;
    font-weight: ${cssOption?.coverC?.descFontBold} !important;
    font-style: ${cssOption?.coverC?.descFontItalic} !important;
    text-decoration: ${cssOption?.coverC?.descFontUnderline} !important;
  }
   .cover-leval .tips p {
      font-size: ${((cssOption?.coverC?.descFont * 2) / 50).toFixed(
    2
  )}rem !important;
   }
  .cover-leval .start-btn {
    font-size: ${((cssOption?.coverC?.btnFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.coverC?.btnColor} !important;
    font-weight: ${cssOption?.coverC?.btnFontBold} !important;
    font-style: ${cssOption?.coverC?.btnFontItalic} !important;
    text-decoration: ${cssOption?.coverC?.btnFontUnderline} !important;
  }
`
  if (coverC.compBtnBgStartColor || coverC.compBtnBgEndColor) {
    const defaultStartColor = quesInfo?.themeType === 1 ? '#ff9c2e' : '#40afff'
    const defaultEndColor =  quesInfo?.themeType === 1 ? '#ffde3a' :  '#3573fa'

    css += `
    .cover-leval .start-btn {
      background: linear-gradient(
        -90deg
        , ${coverC.compBtnBgStartColor || defaultStartColor} 0%, ${coverC.compBtnBgEndColor || defaultEndColor} 100%) !important;
    }
  `
  }

  if (coverC.btnRadius) {
    css += `
    .cover-leval .start-btn {
      border-radius: ${((coverC.btnRadius || 44) / 50).toFixed(2)}rem !important;
    }
  `
  }

  // tips 背景色
  if (coverC.descBg) {
    css += `
    .cover-leval .tips {
      background-color: ${coverC.descBg} !important;
    }
  `
  }

  // 按钮颜色统一设定
  css += `
  .cover-leval .start-btn,
  .content .close-btn,
  .result-tips .fish-btn,
  .content .list-wrap .selected,
  .result-wrap .finish-btn {
    box-shadow: ${cssOption?.coverC?.btnBgColor ? 'none !important' : ''};
    background: ${cssOption?.coverC?.btnBgColor ? 'none !important' : ''};
    color: ${cssOption?.coverC?.btnColor} !important;
    background-color: ${cssOption?.coverC?.btnBgColor} !important;
  }
  `
  // 闯关封面背景
  if (cssOption?.coverC?.coverType === 1 && cssOption?.coverC?.bgImg) {
    css += `
    .cover-leval {
      background: no-repeat top/100% url(${cssOption?.coverC?.bgImg}) !important;
    }
    .cover-leval .logo {
      visibility: hidden;
    }
    `
  } else if (cssOption?.coverC?.coverType === 2) {
    // 纯色背景
    css += `
    .cover-leval {
      background-image: none !important;
      background-color: ${cssOption?.coverC?.coverColor} !important;
    }
    `
  }

  // 闯关按钮位置
  if (cssOption?.coverC?.btnPosition === 'top') {
    css += `
    .cover-leval .start-btn {
      margin-top: -9rem !important;
    }
    `
  } else if (cssOption?.coverC?.btnPosition === 'center') {
    css += `
    .cover-leval .start-btn {
      margin-top: 3rem !important;
    }
    `
  } else if (cssOption?.coverC?.btnPosition === 'center') {
    css += `
    .cover-leval .start-btn {
      margin-top: 14.6rem !important;
    }
    `
  }

  // 开始按钮为热区类型
  if (cssOption?.coverC?.btnType === 2) {
    css += `
    .cover-leval .start-btn {
      background: none !important;
      background-color: transparent !important;
      color: transparent !important;
      box-shadow: 0px 0.02rem 0.2rem 0px rgb(254 167 74 / 57%) !important;
    }
    `
  }

  return css
}

// 设置闯关内容页样式
const formatContentCompetitionStyle = (cssOption) => {
  let css = ''
  // 闯关内容/结果页背景
  if (cssOption?.contentC?.bgType === 1 && cssOption?.contentC?.bgImg) {
    css += `
    .content-leval, .result-wrap {
      background: none !important;
    }
    .content-leval, .diy-bg {
      position: fixed;
      top: 0;
      width: 100%;
      min-height: 32.48rem;
      background: no-repeat top/100% url(${cssOption?.contentC?.bgImg}) !important;
      z-index: 0;
    }
    .result-wrap .diy-bg {
      z-index: -1;
    }
    `
  } else if (cssOption?.contentC?.bgType === 2) {
    // 纯色背景
    css += `
    .content-leval, .result-wrap {
      background-image: none !important;
      background-color: ${cssOption?.contentC?.bgColor} !important;
    }
    `
  }
  // 标题字体
  css += `
  .content-leval .main-title {
    visibility: ${
      cssOption.contentC?.showTitle === false ? 'hidden' : 'visiable'
    } !important;
    font-size: ${((cssOption?.contentC?.titleFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.contentC?.titleColor} !important;
    font-weight: ${cssOption?.contentC?.titleFontBold} !important;
    font-style: ${cssOption?.contentC?.titleFontItalic} !important;
    text-decoration: ${cssOption?.contentC?.titleFontUnderline} !important;
  }
  `
  // 题目字体
  css += `
  .content-leval .content .choice-wrap .title {
    font-size: ${((cssOption?.contentC?.quesFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.contentC?.quesColor} !important;
    font-weight: ${cssOption?.contentC?.quesFontBold} !important;
    font-style: ${cssOption?.contentC?.quesFontItalic} !important;
    text-decoration: ${cssOption?.contentC?.quesFontUnderline} !important;
  }`
  // 选项字体
  css += `
  .content-leval .content .choice-wrap .list-item {
    font-size: ${((cssOption?.contentC?.optionFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.contentC?.optionColor} !important;
    font-weight: ${cssOption?.contentC?.optionFontBold} !important;
    font-style: ${cssOption?.contentC?.optionFontItalic} !important;
    text-decoration: ${cssOption?.contentC?.optionFontUnderline} !important;
  }`
  // 规则字体
  css += `
  .content-leval .rule .btn {
    font-size: ${((cssOption?.contentC?.ruleFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.contentC?.ruleColor} !important;
    font-weight: ${cssOption?.contentC?.ruleFontBold} !important;
    font-style: ${cssOption?.contentC?.ruleFontItalic} !important;
    text-decoration: ${cssOption?.contentC?.ruleFontUnderline} !important;
  }`
  return css
}

// 设置闯关结果页样式
const formatResultCompetitionStyle = (cssOption) => {

  const result = cssOption?.resultC || {}
  let css = ''
  console.log('result', result)
  // 背景色/背景图 样式
  if (result?.bgType === 1 && result?.bgImg) {
    css += `
        .result-wrap {
          background: no-repeat top/100% url(${result?.bgImg}) !important;
        }
      `
  } else if (result?.bgType === 2) {
    // 纯色背景
    css += `
        .result-wrap {
          background-image: none !important;
          background-color: ${result?.bgColor} !important;
        }
      `
  }

  // 提示图标
  if (result?.tipImg) {
    css += `
    .result-wrap .result {
      background: no-repeat top/100% url(${result?.tipImg}) !important;
    }
    `
  }

  if (result?.isHideIcon) {
    css += `
    .result-wrap .result {
      display: none !important;
    }
    `
  }

  // 结果窗背景色
  if (result?.resWrapBgColor) {
    css += `
      .result-wrap .infos .infos-detail {
        background-color: ${result?.resWrapBgColor} !important;
      }
    `
  }

  // 答题结果窗上排文字
  css += `
    .result-wrap .infos .infos-detail .infos-detail-item div.normal {
      font-size: ${((result?.resTopFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.resTopFontColor} !important;
      font-weight: ${result?.resTopFontBold} !important;
      font-style: ${result?.resTopFontItalic} !important;
      text-decoration: ${result?.resTopFontUnderline} !important;
    }
  `

  // 答题结果窗下排文字
  css += `
    .result-wrap .infos .infos-detail .infos-detail-item div.grey {
      font-size: ${((result?.resBottomFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.resBottomFontColor} !important;
      font-weight: ${result?.resBottomFontBold} !important;
      font-style: ${result?.resBottomFontItalic} !important;
      text-decoration: ${result?.resBottomFontUnderline} !important;
    }
  `

  // 结果描述字体
  css += `
  .result-wrap .infos-text {
    font-size: ${((cssOption?.resultC?.titleFont * 2) / 50).toFixed(
      2
    )}rem !important;
    color: ${cssOption?.resultC?.titleColor} !important;
    font-weight: ${cssOption?.resultC?.titleFontBold} !important;
    font-style: ${cssOption?.resultC?.titleFontItalic} !important;
    text-decoration: ${cssOption?.resultC?.titleFontUnderline} !important;
  }
  `
  // 结果按钮
  // 完成按钮按钮背景颜色设置
  if (result?.finishBtnBgStartColor || result?.finishBtnBgEndColor) {
    css += `
      .result-wrap .finish-btn {
        background: linear-gradient(
          -90deg
          , ${result?.finishBtnBgStartColor || '#ff9c2e'} 0%, ${
      result?.finishBtnBgEndColor || '#ffde3a'
    } 100%) !important;
      }
    `
  }

  // 完成按钮字体设置
  css += `
    .result-wrap .finish-btn {
      font-size: ${((result?.finishBtnFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.finishBtnColor} !important;
      font-weight: ${result?.finishBtnFontBold} !important;
      font-style: ${result?.finishBtnFontItalic} !important;
      text-decoration: ${result?.finishBtnFontUnderline} !important;
    }
  `

  // 完成按钮圆角设置
  if (result?.finishBtnRadius !== undefined) {
    css += `
      .result-wrap .finish-btn {
        border-radius: ${((result?.finishBtnRadius) / 50).toFixed(
          2
        )}rem !important;
      }
    `
  }

  return css
}

const colorToRgb = (color) => {
  var div = document.createElement('div')
  div.style.backgroundColor = color
  document.body.appendChild(div)
  var c = window.getComputedStyle(div).backgroundColor
  document.body.removeChild(div)
  return c
}


// 设置pk样式
const setPkStyle = (cssOption, quesInfo) => {
  return (
    formatCoverStyle(cssOption, quesInfo) +
    formatContentPkStyle(cssOption, quesInfo) +
    formatResultPkStyle(cssOption, quesInfo)
  )
}

// 设置pk内容页样式
function formatContentPkStyle(cssOption, quesInfo) {
  const content = cssOption?.content || {}

  let css = ''

  // 背景设置
  if (content?.bgType === 1 && content?.bgImg) {
    css += `
    .pk-wrap, .pk-loading-wrap {
      background: no-repeat top/100% url(${content?.bgImg}) !important;
    }
    `
  } else if (content?.bgType === 2) {
    // 纯色背景
    css += `
    .pk-wrap, .pk-loading-wrap {
      background-color: ${content?.bgColor} !important;
    }
    `
  }

   // ques字体
   css += `
    .pk-wrap .content .title {
      font-size: ${((content?.quesFont * 2) / 50).toFixed(2)}rem !important;
      color: ${content?.quesColor} !important;
      font-weight: ${content?.quesFontBold} !important;
      font-style: ${content?.quesFontItalic} !important;
      text-decoration: ${content?.quesFontUnderline} !important;
    }
  `

  // 选项字体
  css += `
    .pk-wrap .content .list-item {
      font-size: ${((content?.optionFont * 2) / 50).toFixed(2)}rem !important;
      color: ${content?.optionColor} !important;
      font-weight: ${content?.optionFontBold} !important;
      font-style: ${content?.optionFontItalic} !important;
      text-decoration: ${content?.optionFontUnderline} !important;
    }
  `

  return css
}

function formatResultPkStyle(cssOption, quesInfo) {
  let css = ''
  const result = cssOption?.result || {}

  // 背景色/背景图 样式
  if (result?.bgType === 1 && result?.bgImg) {
    css += `
      .result-wrap {
        background: no-repeat top/100% url(${result?.bgImg}) !important;
      }
    `
  } else if (result?.bgType === 2) {
    // 纯色背景
    css += `
      .result-wrap {
        background-image: none !important;
        background-color: ${result?.bgColor} !important;
      }
    `
  }

  // 是否隐藏标题图片
  if (result?.isHideIcon) {
    css += `
      .result-wrap .result {
        display: none !important;
      }

      .result-wrap .result-tips {
        margin-top: 0 !important;
        padding-top: ${(350 / 50).toFixed(2)}rem !important;
      }
    `
  }

  // 提示字体样式
  css += `
    .result-wrap .infos-text {
      font-size: ${((result?.titleFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.titleColor} !important;
      font-weight: ${result?.titleFontBold} !important;
      font-style: ${result?.titleFontItalic} !important;
      text-decoration: ${result?.titleFontUnderline} !important;
    }
  `

  // 完成按钮按钮背景颜色设置
  css += `
    .result-wrap .finish-btn {
      background: linear-gradient(
        -90deg
        , ${result?.finishBtnBgStartColor || '#388fff'} 0%, ${
    result?.finishBtnBgEndColor || '#2faeff'
  } 100%) !important;
    }
  `

  // 完成按钮字体设置
  css += `
    .result-wrap .finish-btn {
      font-size: ${((result?.finishBtnFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.finishBtnColor} !important;
      font-weight: ${result?.finishBtnFontBold} !important;
      font-style: ${result?.finishBtnFontItalic} !important;
      text-decoration: ${result?.finishBtnFontUnderline} !important;
    }
  `

  // 完成按钮圆角设置
  css += `
    .result-wrap .finish-btn {
      border-radius: ${((result?.finishBtnRadius || 44) / 50).toFixed(
        2
      )}rem !important;
    }
  `

  // 答题提示背景图,
  if (quesInfo?.type === 3 && result?.tipImg) {
    css += `
      .result-wrap .result {
        background: no-repeat top/100% url(${result?.tipImg}) !important;
      }
    `
  }

  // 答题结果窗背景色
  if (result?.resWrapBgColor) {
    css += `
      .result-wrap .rank-wrap {
        background-color: ${result?.resWrapBgColor} !important;
      }
    `
  }

  // 答题结果窗上排文字
  css += `
    .result-wrap .table-title {
      font-size: ${((result?.resTopFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.resTopFontColor} !important;
      font-weight: ${result?.resTopFontBold} !important;
      font-style: ${result?.resTopFontItalic} !important;
      text-decoration: ${result?.resTopFontUnderline} !important;
    }
  `

  // 答题结果窗下排文字
  css += `
    .result-wrap .table-content, .order {
      font-size: ${((result?.resBottomFont * 2) / 50).toFixed(2)}rem !important;
      color: ${result?.resBottomFontColor} !important;
      font-weight: ${result?.resBottomFontBold} !important;
      font-style: ${result?.resBottomFontItalic} !important;
      text-decoration: ${result?.resBottomFontUnderline} !important;
    }
  `

  return css
}
